export default __webpack_public_path__ + "static/media/lcmslogo.bbf8b401.svg";